import { render, staticRenderFns } from "./dialogReviewPlatformAdd.vue?vue&type=template&id=a77c62d4"
import script from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js"
export * from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js"
import style0 from "./dialogReviewPlatformAdd.vue?vue&type=style&index=0&id=a77c62d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports